"use client";

import WaveBanner from "@/app/components/footer/components/WaveBanner";
import { darken, useMantineTheme } from "@mantine/core";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import AnimatedBackground from "../(auth)/components/AnimatedBackground";
import { useAuthStyles } from "../(auth)/components/AuthContentWrapper";

export default function Layout({ children }: { children: React.ReactNode }) {
  const { classes: authClasses } = useAuthStyles();
  const theme = useMantineTheme();
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY as string}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
    >
      <div className={authClasses.pageWrapper}>
        <AnimatedBackground />
        {children}
      </div>
      <WaveBanner
        colors={{
          light: "white",
          dark: darken(theme.colors.darkblue[9], 0.4),
        }}
      />
    </GoogleReCaptchaProvider>
  );
}
